import globals from "imports/globals";
import $ from "cash-dom";
import "@lottiefiles/lottie-player";
import { gsapTrigger as WyPt } from "Utilities";

const layout = (function () {
    /**
     * Initialize Sticky Lottie instances
     */
    $(document).ready(function () {
        var stickyMarkers = [];
        if ($(".layout-sticky-lottie").length) {
            if (globals.debug) console.log("layout-sticky-lottie initialized");
            $(".layout-sticky-lottie").each(function () {
                var layoutInstance = $(this);
                var player = layoutInstance.find("lottie-player")[0];
                var markers = [];
                var animation = player._lottie;
                var keyframes = layoutInstance.find(".keyframe");
                var keepRatio = player.hasAttribute("data-keep-ratio");

                function setSizes() {
                    // var animationRect = animation.wrapper.children[0];
                    // var animationRatio = parseInt(animationRect.style.height) / parseInt(animationRect.style.width);
                    var animationRatio = player.getAttribute("height") / player.getAttribute("width");
                    var screenRatio = window.innerHeight / window.innerWidth;

                    animation.resize();
                    animation.wrapper.style.transform = `scale(${1 + Math.abs((screenRatio - animationRatio) * 2)})`;
                }

                if (!keepRatio) {
                    setSizes();
                    $(window).on("resize", function () {
                        setSizes();
                    });
                }

                /*
                setTimeout(function () {
                    setSizes();
                }, 500);
                */

                keyframes.each(function () {
                    var caption = $(this).parents(".layout-sticky-lottie").find(".dynamic-caption-inner");
                    markers.push(
                        new WyPt({
                            element: $(this)[0],
                            offset: {
                                top: "top-top",
                                bottom: "bottom-bottom",
                            },
                            callback: {
                                enter: function (_el, _dir) {
                                    if (_dir == "down") {
                                        var el = $(_el);
                                        var from = el.attr("data-from");
                                        var to = el.attr("data-to");
                                        var speed = el.attr("data-speed") ? el.attr("data-speed") : 1.0;
                                        animation.setSpeed(parseFloat(speed));
                                        animation.playSegments([parseInt(from), parseInt(to)], true);
                                        globals.replaceText(_el, caption);
                                    }
                                },
                                leave: function (_el, _dir) {
                                    if (_dir == "up") {
                                        /*
                                        var el = $(_el);
                                        var from = el.attr("data-to");
                                        var to = el.attr("data-from");
                                        */
                                        var el = $(_el).prev();
                                        var from = el.attr("data-from");
                                        var to = el.attr("data-to");
                                        // var to = el.prev().attr("data-to") ? el.prev().attr("data-to") : 0;
                                        var speed = el.prev().attr("data-speed") ? el.prev().attr("data-speed") : 1.0;
                                        animation.setSpeed(parseFloat(speed));
                                        animation.playSegments([parseInt(from), parseInt(to)], true);
                                        globals.replaceText(_el.previousElementSibling, caption);
                                    }
                                },
                            },
                            // debug: true,
                        })
                    );
                });
            });
        }
    });
})();

export default layout;
